import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { CalendarBlankIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Link, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import { actionsReasons, supportEmail } from '@/returns/pages/TransactionDetailPage/constants'

import * as Styles from './styles'

const SchedulePickupTitle = ({ isDisabled, pickupScheduled, allowsSchedulePickupReason }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const { info } = useContext(AppContext)

  const getDate = () => {
    if (pickupScheduled) {
      const date = new Date(pickupScheduled)
      return new Intl.DateTimeFormat(i18n.language, {
        month: 'long',
        day: 'numeric',
        timeZone: info?.selectedStore?.timezone,
      }).format(date)
    }
  }

  return (
    <Styles.Container>
      <Styles.ActionTitleContainer>
        <CalendarBlankIcon size={16} />
        <Text type="bodyMRegular">{t('Programar nueva recogida')}</Text>
      </Styles.ActionTitleContainer>
      {isDisabled && (
        <Text type="bodySRegular" customStyles={{ paddingLeft: '25px' }} color={theme.colors.text.subtle}>
          {allowsSchedulePickupReason === actionsReasons.pickupScheduled &&
            t('Podrás programar una nueva recogida el {{date}}.', { date: getDate() })}
          {allowsSchedulePickupReason === actionsReasons.maxReturnLabels && (
            <>
              {t('Ponte en contacto con nuestro equipo de soporte para programar una nueva recogida en')}{' '}
              <Link href={`mailto:${supportEmail}`}>
                <Text type="linkS">{supportEmail}</Text>
              </Link>
            </>
          )}
        </Text>
      )}
    </Styles.Container>
  )
}

export default SchedulePickupTitle
